/// <reference path="libs/jquery-1.7.2.min.js"/>
/// <reference path="libs/select2/select2.js"/>

var Skarabee = {
    CityAutocompleteXhr: null,
    QueryUrl: null,
    HiddenZipcodes: [],
    Visitor: {
        _loggedIn: false,
        IsLoggedIn: function () {
            return Skarabee.Visitor._loggedIn;
        },
        SetLoggedIn: function (value) {
            Skarabee.Visitor._loggedIn = (value == true);
        }
    },
    SetCookie: function (name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = name + "=" + c_value;
    },

    GetCookie: function (name) {
        var i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x == name) {
                return unescape(y);
            }
        }
        return null;
    },

    FormatMoney: function (integer, c, d, t) {
        /// <summary>
        ///     Format an integer to money format
        /// </summary>
        /// <param name="integer" type="int">
        ///     The value to format
        /// </param>
        /// <param name="c" type="int">
        ///     Amount of decimals to show, after comma
        /// </param>
        /// <param name="d" type="string">
        ///     decimals seperator
        /// </param>
        /// <param name="t" type="string">
        ///     Thousands seperator
        /// </param>
        if (integer == null) return '&euro; -';
        var n = integer, c = isNaN(c = Math.abs(c)) ? 2 : c, d = d == undefined ? "," : d, t = t == undefined ? "." : t, s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
        return '&euro; ' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },

    SearchPublications: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchPublications', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json.TotalCount, json.Publications);
        });
    },
    
    SearchPublicationsForHolidayRent: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchPublicationsForHolidayRent', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json.TotalCount, json.Publications);
        });
    },

    GetStatistics: function(query, callback){
        return $.getJSON(this.QueryUrl + '/GetStatistics', query, function (json) {
            if (typeof (callback) != 'undefined') {
                callback(json);
            }
        });
    },

    SearchPublicationsForShowPuzzler: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchPublicationsForShowpuzzler', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json.TotalCount, json.Publications);
        });
    },
    
    GetPublication: function(id,language,callback) {
        return $.getJSON(this.QueryUrl + '/GetPublication',"id="+ id+"&language="+language, function(json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },
    
    GetTranslation: function(type, value, callback) {
        return $.getJSON(this.QueryUrl + '/GetTranslation',"type="+ type+"&value="+value, function(json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },
    
    GetWebsiteSetting: function (key,callback) {
        return $.getJSON(this.QueryUrl + '/GetWebsiteSetting', "key=" + key, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    GetSubcities: function (cityId, callback) {
        return $.getJSON(this.QueryUrl + '/GetSubCities', "cityId=" + cityId, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    SearchCities: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchCities', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    SearchCountries: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchCountries', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    SearchStreets: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchStreets', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },
    
    SearchZones: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchZones', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    SearchCitiesForProject: function (query, callback) {
        return $.getJSON(this.QueryUrl + '/SearchCitiesForProject', query, function (json) {
            if (typeof (callback) != 'undefined') callback(json);
        });
    },

    CityAutocomplete: function (searchTerm, overwriteOptions, callback) {
        var options = {
            country: null,
            transactiontype: null,
            includeCount: false,
            distinctCityNames: false,
            distinctCityNameMultipleZipcodes: true,
            includeSubCities: false
        };

        $.extend(options, overwriteOptions);

        if (this.CityAutocompleteXhr !== null)
            this.CityAutocompleteXhr.abort();

        this.CityAutocompleteXhr = $.getJSON(this.QueryUrl + '/CityAutocomplete',
            'country=' + options.country + '&searchterm=' + searchTerm + "&transactiontype=" + options.transactiontype + "&includeCount=" + options.includeCount.toString() + "&distinctCityNames=" + options.distinctCityNames + "&distinctCityNameMultipleZipcodes=" + options.distinctCityNameMultipleZipcodes + "&includeSubcities=" + options.includeSubCities,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });

        return this.CityAutocompleteXhr;
    },

    GetEstateCategories: function (callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetEstateCategories', '',
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetEstateSorts: function (estateCategory, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetEstateSorts',
            typeof (estateCategory) == 'undefined' || estateCategory == null ? '' : 'estateCategory=' + estateCategory,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetEstateGenres: function (estateSort, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetEstateGenres',
            typeof (estateSort) == 'undefined' || estateSort == null ? '' : 'estateSort=' + estateSort,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetProtectedList: function (key,subkey, login, password,callback) {
        var that = this;

        return $.getJSON(this.QueryUrl + '/GetProtectedList',
            'key=' + key + "&subkey=" + subkey + "&login=" + login + "&password=" + password,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetEstateCharacterisations: function (estateSort, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetEstateCharacterisations',
            typeof (estateSort) == 'undefined' || estateSort == null ? '' : 'estateSort=' + estateSort,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetTransactionTypes: function (callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetTransactionTypes', '',
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetTransactionFlowStatuses: function (callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetTransactionFlowStatuses', '',
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetZonesForCityName: function (cityName, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetZonesForCityName',
            typeof (cityName) == 'undefined' || cityName == null ? '' : 'cityName=' + cityName,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetMapId: function (cityName, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetMapId',
            typeof (cityName) == 'undefined' || cityName == null ? '' : 'cityName=' + cityName,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetMapList: function (callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetMapList', '',
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetRentPeriods: function (callback) {
        return $.getJSON(this.QueryUrl + '/GetRentPeriods', '',
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },

    GetRentPeriodsForType: function (type, callback) {
        return $.getJSON(this.QueryUrl + '/GetRentPeriodsForType',
            typeof (type) == 'undefined' || type == null ? '' : 'type=' + type,
            function (json) {
                if (typeof (callback) != 'undefined') callback(json);
            });
    },
    GetRentCapacities: function (callback) {
        return $.getJSON(this.QueryUrl + '/GetRentCapacities',
         function (json) {
             if (typeof (callback) != 'undefined') callback(json);
         });
    },
    FacebookLogin: function (accessToken, callback) {
        $.ajax({
            type: 'POST',
            url: this.QueryUrl + '/FacebookLogin',
            data: "accessToken=" + accessToken,
            success: function (data) {
                callback(data);
            }
        });
    },

    SearchEstateCategories: function (query, callback) {
        return this._search('SearchEstateCategories', query, callback);
    },

    SearchEstateSorts: function (query, callback) {
        return this._search('SearchEstateSorts', query, callback);
    },

    SearchEstateGenres: function (query, callback) {
        return this._search('SearchEstateGenres', query, callback);
    },

    SearchCharacterisations: function (query, callback) {
        return this._search('SearchCharacterisations', query, callback);
    },

    GetToppers: function (amount, callback) {
        return this._search('GetToppers', 'amount=' + amount, callback);
    },

    GetSpotlights: function (amount, callback) {
        return this._search('GetSpotlights', 'amount=' + amount, callback);
    },

    GetOpenhouses: function (amount, callback) {
        return this._search('GetOpenhouses', 'amount=' + amount, callback);
    },

    GetMapByLocation: function (latitude, longitude, callback) {
        var that = this;
        return $.getJSON(this.QueryUrl + '/GetMapByLocation?latitude=' + latitude + "&longitude=" + longitude,
            typeof (type) == 'undefined' || type == null ? '' : 'type=' + type,
            function (json) {
                if (typeof (callback) != 'undefined')
                    callback(json);
            });
    },

    SyndixisLogin: function(url, username, password, callback) {
        return $.getJSON(this.QueryUrl + '/SyndixisLogin', 'url=' + url + '&username=' + username + "&password=" + password, function(json) {
                if (typeof (callback) != 'undefined')
                    callback(json);
            }); 
    },

    Favorites: {
        GetPublicationIds: function (callback) {
            var value = Skarabee.GetCookie('SkarabeeCMS-Favorites');
            var ids = [];

            if (value != null) {
                $.each(value.split(','), function () {
                    ids.push(parseInt(this));
                });
            }

            if (typeof (callback) !== 'undefined') callback(ids);
        },

        List: function (callback) {
            return $.getJSON(Skarabee.QueryUrl + '/FavoritesList', function (json) {
                if (typeof (callback) !== 'undefined') callback(json);
            });
        },

        Add: function (publicationId, callback) {
            return $.getJSON(Skarabee.QueryUrl + '/FavoritesAdd', 'publicationId=' + publicationId, function (json) {
                if (typeof (callback) !== 'undefined') callback(json);
            });
        },

        Remove: function (publicationId, callback) {
            return $.getJSON(Skarabee.QueryUrl + '/FavoritesRemove', 'publicationId=' + publicationId, function (json) {
                if (typeof (callback) !== 'undefined') callback(json);
            });
        },

        Clear: function (callback) {
            return $.getJSON(Skarabee.QueryUrl + '/FavoritesClear', function (json) {
                if (typeof (callback) !== 'undefined') callback(json);
            });
        }
    },

    Basket: {
        _basket: undefined,
        List: function (callback) {
            if (typeof (Skarabee.Basket._basket) == 'undefined') {

                return $.getJSON(Skarabee.QueryUrl + '/BasketList', function (result) {

                    if (typeof (callback) !== 'undefined')
                        callback(Skarabee.Basket._basket);
                });
            } else {
                callback(Skarabee.Basket._basket);
            }
        },

        Add: function (publicationId, value) {
            Skarabee.Basket._basket[publicationId.toString()] = value;
            return $.getJSON(Skarabee.QueryUrl + '/BasketAdd', 'id=' + publicationId + '&type=' + value, function (json) {
                if (typeof (callback) !== 'undefined') callback();
            });
        },

        Remove: function (publicationId) {
            if (Skarabee.Basket._basket.hasOwnProperty(publicationId)) {
                delete Skarabee.Basket._basket[publicationId];
            }
            return $.getJSON(Skarabee.QueryUrl + '/BasketRemove', 'id=' + publicationId, function (json) {
                if (typeof (callback) !== 'undefined') callback();
            });
        },

        Set: function (result) {
            Skarabee.Basket._basket = {};
            $.each(result, function (i, el) {
                Skarabee.Basket._basket[el.PublicationId] = el.Type;
            });
        }
    },

    Maps: {
        Options: { url: { searchMaps: null, searchCities: null } },
        CreateOptions: function (obj) {
            return $.extend(this.Options, obj);
        },

        SearchCities: function (cityId, callback) {
            return $.getJSON(this.Options.url.searchCities, { cityid: cityId }, function (json) {
                if (typeof (callback) !== 'undefined') callback(json);
            });
        }
    },

    _search: function (method, query, callback) {
        return $.getJSON(this.QueryUrl + '/' + method, query, function (json) {
            $.each(json, function () {
                var pub = this;
                if (typeof pub.Image !== 'undefined') {
                    pub.Image.Url = function (options) {
                        var parameters = '';
                        $.each(options, function (a, b) {
                            parameters += '&' + a + '=' + b;
                        });
                        return pub.Image.ImageUrl + parameters;
                    };
                }
            });
            if (typeof (callback) !== 'undefined') callback(json);
        });
    },

    FlattenKeyValues: function (keyValues) {
        var obj = {};
        $.each(keyValues, function (j, value) { obj[value.Key] = value.Value; });
        return obj;
    },

    ShuffleArray: function (array) {
        var tmp, current, top = array.length;
        if (top) while (--top) {
            current = Math.floor(Math.random() * (top + 1));
            tmp = array[current];
            array[current] = array[top];
            array[top] = tmp;
        }

        return array;
    },

    Distinct: function (objects, filter) {
        var flags = {};
        var newObjects = objects.filter(function (entry) {
            var value;
            if (typeof (filter) !== 'undefined') {
                value = filter(entry);
            } else {
                value = entry;
            }

            if (flags[value]) {
                return false;
            }
            flags[value] = true;
            return true;
        });
        return newObjects;
    },

    ExtendQuery: function (query, extraquery) {
        if (typeof query === 'string') query = this.QueryStringToObject(query);
        if (typeof extraquery === 'string') extraquery = this.QueryStringToObject(extraquery);
        var obj = $.extend(query, extraquery);
        return $.param(obj);
    },

    QueryStringToObject: function (query) {

        if (query == '') return null;

        var hash = {};

        var vars = query.split("&");

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            var k = decodeURIComponent(pair[0]);
            var v = decodeURIComponent(pair[1]);

            // If it is the first entry with this name
            if (typeof hash[k] === "undefined") {

                if (k.substr(k.length - 2) != '[]')  // not end with []. cannot use negative index as IE doesn't understand it
                    hash[k] = v;
                else
                    hash[k] = [v];

                // If subsequent entry with this name and not array
            } else if (typeof hash[k] === "string") {
                hash[k] = v; // replace it

                // If subsequent entry with this name and is array
            } else {
                hash[k].push(v);
            }
        }
        return hash;
    },

    /// <summary>
    /// Creates a cities autocomplete adds the selected zipcodes
    /// to a hidden input with name zipcodes.
    /// Requires select2 javascript library & jquery
    /// </summary>
    /// <param name="multiple" type="boolean">
    ///     Allow multi-city selection
    /// </param>
    Select2Zipcodes: function (multiple, includeCount, country, distinctCityNames, includeZipcode) {

        if (distinctCityNames == null) {
            distinctCityNames = false;
        }

        if (includeZipcode == null) {
            includeZipcode = true;
        }

        var queryContext = { previousTerm: null, previousResults: null };

        var $input = $('input[name=zipcodes], input[name="MatchCriteria.Zipcodes"]');

        return $input.select2({
            minimumInputLength: 2,
            multiple: multiple,
            withCount: includeCount,
            allowClear: true,
            matcher: function (term, text) {
                return Skarabee.beginsWith(text, term);
            },
            formatNoMatches: function () {
                var text = $input.data("nomatches");
                if (text != null)
                    return text;
                return "No matches found";
            },
            formatInputTooShort: function (input, min) {
                var text = $input.data("inputshort");
                if (text != null) {
                    return text.replace("{0}", min - input.length);
                }
                return "Please enter " + (min - input.length) + " more characters";
            },
            query: function (options) {

                var callback = function (result) {
                    queryContext.previousTerm = options.term;
                    queryContext.previousResults = result;
                    options.callback({
                        results: result,
                        more: false
                    });
                };

                if (queryContext.previousTerm != null && Skarabee.beginsWith(options.term, queryContext.previousTerm)) {
                    var results = [];
                    var match = this.matcher;
                    $.each(queryContext.previousResults, function (i, city) {
                        if (match(options.term, city.Name) || match(options.term.replace(" ", ""), city.Zipcode.replace(" ", "")))
                            results.push(city);
                    });
                    callback(results);
                    return;
                }

                var types = $input.find(':checked');
                var transactiontype = "";
                if (types.length == 1) {
                    transactiontype = types.val();
                }

                Skarabee.CityAutocomplete(options.term, { country: country, transactiontype: transactiontype, includeCount: this.withCount, distinctCityNames: distinctCityNames }, callback);
            },
            formatSelection: function (city) {
                var name = city.Name;
                if (typeof name === 'undefined') {
                    return city.Zipcode;
                }
                return city.Name;
            },
            formatResult: function (city) {
                var s = "<div";
                if (this.withCount && city.Count == 0) {
                    s += " class=\"autocomplete-nocount\"";
                }
                s += "><strong>" + city.Name + (includeZipcode ? " (" + city.Zipcode + ")" : "") + "</strong>";

                if (this.withCount) {
                    s += " <div class='autocomplete-count'>" + city.Count + "</div>";
                }
                s += "</div>";

                return s;
            },
            id: function (city) {
                return city.Zipcode;
            },
            initSelection: function (element, callback) {
                if (multiple) {
                    var data = [];
                    $(element.val().split(",")).each(function () {
                        data.push({ Zipcode: this });
                    });
                    callback(data);
                } else {
                    callback({ Zipcode: element.val() });
                }
            }
        });
    },

    Select2ZipcodesCities: function (multiple, includeCount, country, distinctCityNames, showPostcode, distinctCityNameMultipleZipcodes) {
        if (distinctCityNames == null) {
            distinctCityNames = false;
        }

        if (showPostcode == null) {
            showPostcode = true;
        }

        if (distinctCityNameMultipleZipcodes == null) {
            distinctCityNameMultipleZipcodes = true;
        }

        var queryContext = { previousTerm: null, previousResults: null, currentXhr: null };

        var $input = $('input[name=zipcodescities], input[name="MatchCriteria.ZipcodesCities"]');

        return $input.select2({
            minimumInputLength: 2,
            multiple: multiple,
            withCount: includeCount,
            allowClear: true,
            matcher: function (term, text) {
                return Skarabee.beginsWith(text, term);
            },
            formatNoMatches: function () {
                var text = $input.data("nomatches");
                if (text != null)
                    return text;
                return "No matches found";
            },
            formatInputTooShort: function (input, min) {
                var text = $input.data("inputshort");
                if (text != null) {
                    return text.replace("{0}", min - input.length);
                }
                return "Please enter " + (min - input.length) + " more characters";
            },
            query: function (options) {

                var callback = function (result) {
                    queryContext.previousTerm = options.term;
                    queryContext.previousResults = result;
                    options.callback({
                        results: result,
                        more: false
                    });
                };

                if (queryContext.previousTerm != null && Skarabee.beginsWith(options.term, queryContext.previousTerm)) {
                    var results = [];
                    var match = this.matcher;
                    $.each(queryContext.previousResults, function (i, city) {
                        if (match(options.term, city.Name) || match(options.term.replace(" ", ""), city.Zipcode.replace(" ", "")))
                            results.push(city);
                    });
                    callback(results);
                    return;
                }

                var types = $input.find(':checked');
                var transactiontype = "";
                if (types.length == 1) {
                    transactiontype = types.val();
                }

                if (queryContext.currentXhr != null) {
                    queryContext.currentXhr.abort();
                }
                queryContext.currentXhr = Skarabee.CityAutocomplete(options.term, { country: country, transactiontype: transactiontype, includeCount: this.withCount, distinctCityNames: distinctCityNames, distinctCityNameMultipleZipcodes: distinctCityNameMultipleZipcodes }, callback);

                queryContext.currentXhr.done(function () {
                    queryContext.currentXhr = null;
                });
            },
            formatSelection: function (city) {
                var name = city.Name;
                if (typeof name === 'undefined') {
                    return city.Zipcode;
                }
                var output = city.Name;
                if (showPostcode) {
                    output = output + " (" + city.Zipcode + ")";
                }
                return output;
            },
            formatResult: function (city) {
                var s = "<div";
                if (this.withCount && city.Count == 0) {
                    s += " class=\"autocomplete-nocount\"";
                }

                s += "><strong>" + city.Name + (showPostcode ? " (" + city.Zipcode + ")" : "") + "</strong>";

                if (this.withCount) {
                    s += " <div class='autocomplete-count'>" + city.Count + "</div>";
                }
                s += "</div>";

                return s;
            },
            id: function (city) {
                return city.Zipcode + "|" + city.Name;
            },
            initSelection: function (element, callback) {
                if (multiple) {
                    var data = [];
                    $(element.val().split(",")).each(function () {
                        var zipcodeCity = this.split("|");
                        data.push({ Zipcode: zipcodeCity[0], Name: zipcodeCity[1] });
                    });
                    callback(data);
                } else {
                    var zipcodeCity = element.val().split("|");
                    callback({ Zipcode: zipcodeCity[0], Name: zipcodeCity[1] });
                }
            }
        });
    },

    Select2Cities: function (multiple, includeCount, country, distinctCityNames, distinctCityNameMultipleZipcodes) {

        if (distinctCityNames == null) {
            distinctCityNames = false;
        }

        if (distinctCityNameMultipleZipcodes == null) {
            distinctCityNameMultipleZipcodes = true;
        }

        var queryContext = { previousTerm: null, previousResults: null };

        var $input = $('input[name=cities], input[name="MatchCriteria.Cities"]');

        return $input.select2({
            minimumInputLength: 2,
            multiple: multiple,
            withCount: includeCount,
            allowClear: true,
            matcher: function (term, text) {
                return Skarabee.beginsWith(text, term);
            },
            formatNoMatches: function () {
                var text = $input.data("nomatches");
                if (text != null)
                    return text;
                return "No matches found";
            },
            formatInputTooShort: function (input, min) {
                var text = $input.data("inputshort");
                if (text != null) {
                    return text.replace("{0}", min - input.length);
                }
                return "Please enter " + (min - input.length) + " more characters";
            },
            query: function (options) {

                var callback = function (result) {
                    queryContext.previousTerm = options.term;
                    queryContext.previousResults = result;
                    options.callback({
                        results: result,
                        more: false
                    });
                };

                if (queryContext.previousTerm != null && Skarabee.beginsWith(options.term, queryContext.previousTerm)) {
                    var results = [];
                    var match = this.matcher;
                    $.each(queryContext.previousResults, function (i, city) {
                        if (match(options.term, city.Name) || match(options.term.replace(" ", ""), city.Zipcode.replace(" ", "")))
                            results.push(city);
                    });
                    callback(results);
                    return;
                }

                var types = $input.find(':checked');
                var transactiontype = "";
                if (types.length == 1) {
                    transactiontype = types.val();
                }

                Skarabee.CityAutocomplete(options.term, { country: country, transactiontype: transactiontype, includeCount: this.withCount, distinctCityNames: distinctCityNames, distinctCityNameMultipleZipcodes: distinctCityNameMultipleZipcodes }, callback);
            },
            formatSelection: function (city) {
                var name = city.Name;
                if (typeof name === 'undefined') {
                    return city.Zipcode;
                }
                return city.Name;
            },
            formatResult: function (city) {
                var s = "<div";
                if (this.withCount && city.Count == 0) {
                    s += " class=\"autocomplete-nocount\"";
                }

                s += "><strong>" + city.Name + "<span class='select2-zipcode'> (" + city.Zipcode + ") </span></strong>";



                if (this.withCount) {
                    s += " <div class='autocomplete-count'>" + city.Count + "</div>";
                }
                s += "</div>";

                return s;
            },
            id: function (city) {
                return city.Name;
            },
            initSelection: function (element, callback) {
                if (multiple) {
                    var data = [];
                    $(element.val().split(",")).each(function () {
                        data.push({ Zipcode: this });
                    });
                    callback(data);
                } else {
                    callback({ Zipcode: element.val() });
                }
            }
        });
    },

    addToSelect2: function (zipcode, name, otherZips, inInterface, suffix) {
        var $input = $('input[name=zipcodes], input[name="MatchCriteria.Cities"], input[name=cities],input[name=zipcodescities]');
        var zipIds = $.map(this.HiddenZipcodes, function (i, el) { return el.Zipcode; });

        if (otherZips != undefined && otherZips.length > 0) {
            if (otherZips[0] != null && $.inArray(otherZips[0], zipIds) === -1) {
                this.HiddenZipcodes.push({
                    zipId: otherZips[0],
                    zipcodes: otherZips
                });
            }
        } else {
            if (zipcode != undefined) {
                if ($.inArray(zipcode, zipIds) === -1) {
                    this.HiddenZipcodes.push({
                        zipId: zipcode,
                        zipcodes: [zipcode]
                    });
                }
            }
        }
        if (inInterface != undefined && inInterface == true) {
            var existingData = $input.select2('data');


            //voeg tekst suffix (+ deelgem.) toe aan de naam
            if (otherZips != undefined && otherZips.length > 1 && suffix != undefined) {
                name = name + suffix;
            }
            $input.select2('data', $.merge(existingData, [{ Zipcode: zipcode, Name: name }]));
        }
    },


    removeFromSelect2: function (zipcodes, inInterface) {
        var $input = $('input[name=zipcodes], input[name="MatchCriteria.Cities"], input[name=cities],input[name=zipcodescities]');
        if (zipcodes != undefined && zipcodes.length > 0) {
            var zipIds = $.map(this.HiddenZipcodes, function (el) {
                return el.zipId;
            });

            if (!$.isArray(zipcodes)) {
                var zipcodes = $.makeArray(zipcodes);
            }

            this.HiddenZipcodes = $.grep(this.HiddenZipcodes, function (el) {
                return $.inArray(el.zipId, zipcodes) === -1;
            });
        }

        if (inInterface != undefined && inInterface == true) {
            var data = $input.select2('data');
            data = $.grep(data, function (el) {
                return $.inArray(el.Zipcode, zipcodes) === -1;
            });
            $input.select2('data', data);
        }
    },

    bindChangeToSelect2: function (added, removed) {
        var $input = $('input[name=zipcodes], input[name="MatchCriteria.Cities"], input[name=cities],input[name=zipcodescities]');

        $input.change(function (event) {
            if (event.removed != undefined && removed != undefined) {
                removed(event);
            }
            if (event.added != undefined && added != undefined) {
                added(event);
            }
        });
    },


    endsWith: function (str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    },

    beginsWith: function (str, prefix) {
        return str.toUpperCase().indexOf(prefix.toUpperCase()) == 0;
    },

    translateCitiesBrussels: function (city) {
    	var citiesBxl = [
			{ nl: "Oudergem", fr: "Auderghem", val: "Oudergem,Auderghem" },
			{ nl: "Sint-Agatha Berchem", fr: "Berchem-Sainte-Agathe", val: "Sint-Agatha Berchem,Berchem-Sainte-Agathe" },
			{ nl: "Brussel", fr: "Bruxelles", val: "Brussel,Bruxelles,Bruxelles (1000)" },
			{ nl: "Elsene", fr: "Ixelles", val: "Elsene,Ixelles" },
			{ nl: "Vorst", fr: "Forest", val: "Vorst,Forest" },
			{ nl: "Sint-Jans-Molenbeek", fr: "Molenbeek-Saint-Jean", val: "Sint-Jans-Molenbeek,Molenbeek-Saint-Jean" },
			{ nl: "Sint-Gillis", fr: "Saint-Gilles", val: "Sint-Gillis,Saint-Gilles" },
			{ nl: "Sint-Joost-ten-Node", fr: "Saint-Josse-ten-Noode", val: "Sint-Joost-ten-Node,Saint-Josse-ten-Noode" },
			{ nl: "Sint-Lambrechts-Woluwe", fr: "Woluwe-Saint-Lambert", val: "Sint-Lambrechts-Woluwe,Woluwe-Saint-Lambert" },
			{ nl: "Sint-Pieters-Woluwe", fr: "Woluwe-Saint-Pierre", val: "Sint-Pieters-Woluwe,Woluwe-Saint-Pierre" },
			{ nl: "Ukkel", fr: "Uccle", val: "Ukkel,Uccle" },
			{ nl: "Watermaal-Bosvoorde", fr: "Watermael-Boitsfort", val: "Watermaal-Bosvoorde,Watermael-Boitsfort" },
			{ nl: "Schaarbeek", fr: "Schaerbeek", val: "Schaarbeek,Schaerbeek" }
    	];
    	for (var i = 0; i<citiesBxl.length; i++) {
    		if (citiesBxl[i].nl == city || citiesBxl[i].fr == city) {
    			return citiesBxl[i];
    		}
    	}
    }
};

//(function() {
//    var setRatioCookie = function (ratio) {
//        var date = new Date();
//        date.setTime(date.getTime() + 3600000);
//        document.cookie = 'device_pixel_ratio=' + ratio + ';' + ' expires=' + date.toUTCString() + '; path=/';
//    }

//    var restartAfterLoad = document.cookie.indexOf('device_pixel_ratio') == -1;

//    if ('devicePixelRatio' in window && window.devicePixelRatio > 1) {
//        setRatioCookie(window.devicePixelRatio);
//    } else {
//        setRatioCookie(1);
//    }

//    if (restartAfterLoad) {
//        //if cookies are not blocked, reload the page
//        if (document.cookie.indexOf('device_pixel_ratio') != -1) {
//            window.location.reload();
//        }
//    }
//})();

if (typeof (jQuery) !== 'undefined') {

    $.ajaxSetup({
        cache: false
    });

    //JQuery extensions for validation

    var setValidationValues = function (options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    };

    if (typeof (jQuery.validator) !== 'undefined') {
        jQuery.validator.addMethod("requiredcontactvalidationtype", function (value, element, param) {
            var $el = $(element);
            var $form = $el.parents('form');
            var req = $form.find("[name='ContactMe.RequiredValidation'], [name='ContactInfo.RequiredValidation']").val();
            if (req == null) {
                req = 'Email, MobilePhone';
            }
            var reqs = req.split(', ');

            var ok = true;
            $.each(reqs, function () {
                var reqString = this.toString();
            
                var isFieldEmpty = function (field) {

                    var v = $form.find("[name='ContactMe." + field + "'], [name = 'ContactInfo." + field + "']").val();
                    if (v != null) {
                        v = v.replace(/\s*/, "");
                    }

                    if (v == null || v == '') {
                        return true;
                    }

                    return false;
                };

                if ($el.attr('name') == 'ContactMe.' + reqString || $el.attr('name') == 'ContactInfo.' + reqString) {
                    if (isFieldEmpty(reqString)) {
                        ok = false;
                    }
                };
               
                if (ok == true) {
                    switch (reqString) {
                        case "PhoneOrMobilePhoneOrEmail":
                            if (isFieldEmpty('MobilePhone') && isFieldEmpty('Email') && isFieldEmpty('Phone')) {
                                ok = false;
                                $('[data-valmsg-for="ContactMe.Email"]').hide();
                                $('[data-valmsg-for="ContactInfo.Email"]').hide();
                                $('[data-valmsg-for="ContactMe.MobilePhone"]').hide();
                                $('[data-valmsg-for="ContactInfo.MobilePhone"]').hide();
                                $('[data-valmsg-for="ContactMe.Phone"]').hide();
                                $('[data-valmsg-for="ContactInfo.Phone"]').hide();
                                $('.requiredvalidation-message').show();
                            } else {
                                $('.requiredvalidation-message').hide();
                            }
                            break;
                    }
                }

            });
            return ok;
        });

        jQuery.validator.unobtrusive.adapters.add("requiredcontactvalidationtype", function (options) {
            setValidationValues(options, "requiredcontactvalidationtype", true);
        });



        jQuery.validator.unobtrusive.adapters.addBool("mandatory", "required");

//        jQuery.validator.unobtrusive.parse();
    }
}
